/**
 * Persistencia de las preferencias de audio (por ahora solo "silenciado").
 * Mismo patrón que `save.ts`: clave versionada propia en localStorage y
 * `SaveStorage` inyectable para poder testear sin un `localStorage` real.
 *
 * Lógica pura: no depende de Phaser ni de la Web Audio API — solo lee y
 * escribe un objeto plano.
 */

import { getDefaultStorage, type SaveStorage } from './save';

export const AUDIO_PREFS_KEY = 'vyv:audio:v1';

export interface AudioPrefs {
  muted: boolean;
}

function defaultAudioPrefs(): AudioPrefs {
  return { muted: false };
}

/** Carga las preferencias de audio guardadas, o los valores por defecto si no hay nada (o el JSON es inválido). */
export function loadAudioPrefs(storage: SaveStorage = getDefaultStorage()): AudioPrefs {
  const raw = storage.getItem(AUDIO_PREFS_KEY);
  if (!raw) return defaultAudioPrefs();
  try {
    const parsed = JSON.parse(raw) as Partial<AudioPrefs>;
    return { muted: typeof parsed.muted === 'boolean' ? parsed.muted : false };
  } catch {
    // JSON corrupto: no tumbamos el audio, arrancamos con los valores por defecto.
    return defaultAudioPrefs();
  }
}

/** Guarda las preferencias de audio (se llama tras cada cambio de mute). */
export function saveAudioPrefs(prefs: AudioPrefs, storage: SaveStorage = getDefaultStorage()): void {
  storage.setItem(AUDIO_PREFS_KEY, JSON.stringify(prefs));
}
